import {
  getComponents,
  getGlobalStyles,
  getTypography,
  palettes,
} from "@theatticusapp/atticus-shared-components";
import { createTheme, Theme } from "@mui/material/styles";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme { }
}

const defaultTheme = createTheme();

// override theme attributes (temp or not) here
//  SEE EXAMPLES BELOW
// TODO: move to shared
palettes.light.background = {
  default: "#F9FAFE",
};

// TODO: move to shared
const modifiedComponents = getComponents(palettes.light);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
modifiedComponents.MuiDrawer = {
  styleOverrides: {
    paper: {
      boxShadow:
        "0px 8px 10px -5px rgba(116, 135, 164, 0.2), 0px 16px 24px 2px rgba(116, 135, 164, 0.14), 0px 6px 30px 5px rgba(116, 135, 164, 0.12)",
    },
  },
};
modifiedComponents.MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: "8px",
      // width: 800,
      // [defaultTheme.breakpoints.down("sm")]: {
      //   width: "80%",
      // },
      // [defaultTheme.breakpoints.down("xs")]: {
      //   width: "90%",
      // },
      [defaultTheme.breakpoints.up("md")]: {
        minWidth: 800,
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: palettes.light,
  typography: getTypography(palettes.light), // modifiedTypography
  components: modifiedComponents, //getComponents(palettes.light), // modifiedComponents
});

export const { styles } = getGlobalStyles(palettes.light);

export const atticusColors = {
  white: "#FFFFFF",
  green1: "#27B8AB",
  green2: "#01D9C6",
  greenAlpha1: "rgba(1, 217, 198, 0.1)",
  purple0: "#B5BFDA",
  purple1: "#643BAE",
  purple2: "#6363FF",
  purple3: "#4E57AA",
  purple35: "#656FC4",
  purple4: "#2D2A5C",
  purple5: "#D8D8FF",
  purple6: "#9292FF",
  purple7: "#F5F6FA",
  silver1: "#CDCDDB",
  silver2: "#EDEDF4",
  blue1: "#2C2CFE",
  black: "#000000",
  grey1: "#393A3D",
  grey2: "#595A5F",
  grey3: "#77797E",
  grey4: "#96979C",
  grey5: "#B5B7BA",
  grey6: "#D5D6D7",
  grey7: "#F4F5F5",
  grey8: "#F9FAFA", // not in design specs
  red1: "#FF0000", // not in design specs
  red2: "#d32f2f", // not in design specs
  magenta: "#a52651",
  pink: "#BD698D",
  turquoise: "#196e83",
  lightYellow: "#FECE80",
  fileBackgroundBlue: "#f2f2ff",
  fileBorderBlue: "#9292ff",
};

/*
// EXAMPLE palettes modification
palettes.light.success = {
  light: atticusColors.purple1,
  main: atticusColors.purple2,
};
*/

/*
// EXAMPLE component modification
const modifiedTypography = getTypography(palettes.light);
TODO: create example
*/

/*
// EXAMPLE component modification
const modifiedComponents = getComponents(palettes.light);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
modifiedComponents.MuiButton.styleOverrides.containedSecondary = {
  "&:hover": {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    backgroundColor: palettes.light?.secondary?.light,
    boxShadow: "none",
  },
};
*/
